<template>
  <div v-if="updatedSurvey">
    <SurveyTabCreate
      v-if="isMissingSurvey"
      :project="project"
      :survey="updatedSurvey"
      @showOverviewTab="showOverviewTab"
      @refreshSurveyTabAfterCreate="refreshSurveyTabAfterCreate"
    ></SurveyTabCreate>
    <SurveyTabEdit
      v-else
      :survey="updatedSurvey"
    ></SurveyTabEdit>
  </div>
</template>

<script>
import SurveyTabCreate from "@/components/project/SurveyTabCreate.vue";
import SurveyTabEdit from "@/components/project/SurveyTabEdit.vue";

export default {
  name: 'SurveyTab',
  components: {
    SurveyTabCreate,
    SurveyTabEdit
  },
  props: {
    project: { type: Object, default: null },
    survey: { type: Object, default: null },
  },
  data() {
    return {
      updatedSurvey: null,
      // isMissingSurvey: false,
    };
  },
  computed: {
    isMissingSurvey() {
      return this.updatedSurvey.questions.length === 0;
    },
  },
  mounted() {
    this.updatedSurvey = this.survey;
  },
  watch: {
    survey(survey) {
      this.updatedSurvey = survey;
    }
  },
  methods: {
    showOverviewTab() {
      this.$emit('showOverviewTab');
    },
    refreshSurveyTabAfterCreate(questions) {
      // this.$emit('refreshSurveyTabAfterCreate', questions);
      const survey = {...this.updatedSurvey};
      survey.questions = questions;
      this.updatedSurvey = {...survey};
    }
  }
}
</script>
